import * as types from "./mutationTypes";

export default {
  [types.SET_DEALTS](state, { dealts }) {
    state.dealts = dealts;
  },
  [types.SET_QUERY_PARAMS](state, { params }) {
    state.queryParams = {
      ...state.queryParams,
      ...params
    };
  },
  [types.CLEAR_DEALTS_STATE](state) {
    state.dealts = [];
    state.queryParams = {};
  },
  [types.SET_VISIBLECOLUMNS](state, { metadataSelected }) {
    state.visibleColumns = metadataSelected;
  },
  [types.SET_DEALT](state, { dealt }) {
    state.dealt = dealt;
  },
  [types.CLEAR_DEALT](state) {
    state.dealt = {};
  }
};
